// src/components/molecules/UserProfile/Edit/ProfilePicture/ProfileImage.js

import React from 'react';
import { Avatar } from "@mui/material";

const ProfileImage = ({ src }) => {
  return (
    <Avatar
      src={src}
      alt="Profile Image"
      sx={{
        width: { xs: 80, sm: 120 },
        height: { xs: 80, sm: 120 },
        mx: "auto",
      }}
    />
  );
};

export default ProfileImage;